import ConfigManager from "@/config/ConfigManager";
import BzbsApi from "@/core/Http/BzbsApi.js";
import {
    EditProfileParamsBuilder,
    // AddressParamsBuilder,
    ShippingAddressParamsBuilder
} from "@/core/Account/model/AccountModel.js";

import { map } from "rxjs/operators";

/**
 * @method getProfile
 * @method getProfileSSO
 * @method getPoint
 * @method updateProfile
 * @method updateProfileSSO
 * @method updateConsent
 * @method updateShippingAddress
 * @method registerUser
 * @method changePassword
 * @method registerLine
 * @method apiGetQRCode
 * @method apiNestleMaintenance
 */
export default {
    /**
     * Get user profile.
     * @param {object} token
     */
    getProfile: function(token) {
        const url = ConfigManager.getApiUrl() + "/profile/me";
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetData(url, token)
                .then(response => {
                    // console.log(response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    /**
     * Get user profile.
     * @param {object} token
     */
    getProfileSSO: function(token) {
        const url = ConfigManager.getApiModuleUrl() + "/profile";
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetData(url, token)
                .then(response => {
                    // console.log(response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getProfileNestle: function(strBzbsToken) {
        var strUrl = ConfigManager.getApiModuleUrl() + "/profile";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken);
    },

    getExpirePoint: function(token) {
        const url =
            ConfigManager.getApiUrl() +
            "/profile/me/allexpiring_points?device_app_id=" +
            ConfigManager.getAppId();
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetData(url, token)
                .then(response => {
                    // console.log(response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    getExpirePointDate: function(token) {
        const url =
            ConfigManager.getApiUrl() +
            "/profile/me/expiring_points?device_app_id=" +
            ConfigManager.getAppId();
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetData(url, token)
                .then(response => {
                    // console.log(response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    /**
     * Get point.
     * @param {string} token
     */
    getPoint: function(token) {
        const url = ConfigManager.getApiUrl() + "/profile/me/updated_points";
        return BzbsApi.connectBzbsGet(url, token, null).pipe(
            map(res => {
                const pointObject = res.data;
                return pointObject;
            })
        );
    },

    /**
     * Update user profile.
     * @param {string} token
     * @param {object} objProfileInfo
     * @param {object} objProfileAdress
     * @param {string} strExtendJson
     * @param {string} strUploadKey
     * @param {object} objUpload
     */
    updateProfile: function(
        token,
        profile
        // profileAddress,
        // strExtendJson,
        // strUploadKey,
        // objUpload
    ) {
        const profileParams = new EditProfileParamsBuilder();
        var params = profileParams.getParams(profile);
        // if (profileAddress) {
        //     const addressParams = new AddressParamsBuilder();
        //     var addr = addressParams.getParams(profileAddress);
        //     params = { ...params, ...addr };
        // }

        // if (strExtendJson) params.extendjsonstring = strExtendJson;

        console.log("profileparams", params);

        const url = ConfigManager.getApiUrl() + "/profile/me";
        return BzbsApi.connectBzbsPost(
            url,
            token,
            params
            // strUploadKey,
            // objUpload
        ).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    /**
    * Get point.
    * @param {string} token
    */
    apiNestleMaintenance: function() {
        let date = new Date()
        let params = {
            sponsorId: ConfigManager.getSponsorId(),
            device_app_id: ConfigManager.getAppId(),
            v: Date.parse(date)
        }
        const url = ConfigManager.getApiUrl() + "/dashboard/nescafestreetcafe_crm_maintenance";
        return BzbsApi.connectBzbsGet(url, null, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * Update user profile.
     * @param {string} token
     * @param {object} objProfileInfo
     * @param {object} objProfileAdress
     * @param {string} strExtendJson
     * @param {string} strUploadKey
     * @param {object} objUpload
     */
    updateProfileSSO: function(token, params) {
        const url = ConfigManager.getApiModuleUrl() + "/profile";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * Update user consent.
     * @param {string} token
     * @param {object} objData
     */
    updateConsent: function(token, objData) {
        console.log(objData);
        var url = ConfigManager.getApiModuleUrl() + "/profile/consent";
        const params = {
            ...objData
        };

        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * Update user shipping address.
     * @param {string} token
     * @param {object} objProfileShippingAddress
     */
    updateShippingAddress: function(token, objProfileShippingAddress) {
        const paramsShipping = new ShippingAddressParamsBuilder();
        const params = paramsShipping.getParams(objProfileShippingAddress);

        const url = ConfigManager.getApiUrl() + "/profile/me/shipping";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    registerUserWithParams: function(params) {
        params.app_id = ConfigManager.getAppId();

        const url = ConfigManager.getApiUrl() + "/auth/register";
        return BzbsApi.connectBzbsPost(url, null, params, null, null).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    registerUser: function(
        objRegisterModel,
        haveOTP,
        objRegisterOTPModel,
        objRegisterDeviceInfoModel,
        objRegisterAddressModel,
        objRegisterOtherInfoModel
    ) {
        var params = {
            app_id: ConfigManager.getAppId()
        };

        if (!objRegisterModel) {
            return null;
        }

        if (haveOTP && !objRegisterOTPModel) {
            return null;
        }

        //Basic info.
        if (objRegisterModel.strUsername)
            params.username = objRegisterModel.strUsername;

        if (objRegisterModel.strPassword)
            params.password = objRegisterModel.strPassword;

        if (objRegisterModel.strConfirmPassword)
            params.confirmpassword = objRegisterModel.strConfirmPassword;

        if (objRegisterModel.strFirstname)
            params.firstname = objRegisterModel.strFirstname;

        if (objRegisterModel.strLastname)
            params.lastname = objRegisterModel.strLastname;

        if (objRegisterModel.strEmail) params.email = objRegisterModel.strEmail;

        if (objRegisterModel.strContactNumber)
            params.contact_number = objRegisterModel.strContactNumber;

        if (objRegisterModel.strBirthDate)
            params.birthdate = objRegisterModel.strBirthDate;

        if (objRegisterModel.strNationalID)
            params.idcard = objRegisterModel.strNationalID;

        if (objRegisterModel.strGender)
            params.gender = objRegisterModel.strGender;

        //OTP.
        if (objRegisterOTPModel) {
            if (objRegisterOTPModel.strOTP)
                params.otp = objRegisterOTPModel.strOTP;

            if (objRegisterOTPModel.strRefCode)
                params.refcode = objRegisterOTPModel.strRefCode;
        }

        //Device info.
        if (objRegisterDeviceInfoModel) {
            if (objRegisterDeviceInfoModel.strCarrier)
                params.carrier = objRegisterDeviceInfoModel.strCarrier;

            if (objRegisterDeviceInfoModel.strClientVersion)
                params.client_version =
                    objRegisterDeviceInfoModel.strClientVersion;

            if (objRegisterDeviceInfoModel.strOperationSystem)
                params.os = objRegisterDeviceInfoModel.strOperationSystem;

            if (objRegisterDeviceInfoModel.strPlatform)
                params.platform = objRegisterDeviceInfoModel.strPlatform;

            if (objRegisterDeviceInfoModel.strMacAddress)
                params.mac_address = objRegisterDeviceInfoModel.strMacAddress;
        }

        if (objRegisterAddressModel) {
            if (objRegisterAddressModel.strAddress)
                params.address = objRegisterAddressModel.strAddress;

            if (objRegisterAddressModel.strZipcode)
                params.zipcode = objRegisterAddressModel.strZipcode;

            if (objRegisterAddressModel.strProvinceCode)
                params.province_code = objRegisterAddressModel.strProvinceCode;

            if (objRegisterAddressModel.strProvinceName)
                params.province_name = objRegisterAddressModel.strProvinceName;

            if (objRegisterAddressModel.strDistrictCode)
                params.district_code = objRegisterAddressModel.strDistrictCode;

            if (objRegisterAddressModel.strDistrictName)
                params.district_name = objRegisterAddressModel.strDistrictName;

            if (objRegisterAddressModel.strSubDistrictCode)
                params.subdistrict_code =
                    objRegisterAddressModel.strSubDistrictCode;

            if (objRegisterAddressModel.strSubDistrictName)
                params.subdistrict_name =
                    objRegisterAddressModel.strSubDistrictName;

            if (objRegisterAddressModel.strLatitude)
                params.latitude = objRegisterAddressModel.strLatitude;

            if (objRegisterAddressModel.strLongitude)
                params.longitude = objRegisterAddressModel.strLongitude;
        }

        if (objRegisterOtherInfoModel) {
            if (objRegisterOtherInfoModel.strInfo)
                params.info = objRegisterOtherInfoModel.strInfo;

            if (objRegisterOtherInfoModel.strCustomInfo)
                params.custom_info = objRegisterOtherInfoModel.strCustomInfo;
        }

        const url = ConfigManager.getApiUrl() + "/auth/register";
        return BzbsApi.connectBzbsPost(url, null, params, null, null).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * Change bzbs password
     * @param {string} token
     * @param {string} strCurrent Current password
     * @param {string} strChange New password
     */
    changePassword: function(token, strCurrent, strChange) {
        var params = {
            current: strCurrent,
            change: strChange
        };

        const url = ConfigManager.getApiUrl() + "/profile/me/change_password";
        return BzbsApi.connectBzbsPost(url, token, params, null, null).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * @param {ProfileParamsBuilder, EditProfileParamsBuilder} params (required) /core/Account/model/AccountModel.js
     * @param {string} lineIdToken (required)
     * @param {string} refcode (optional)
     * @param {string|number} otp (optional)
     */
    registerLine: function(profileParams, lineIdToken, refcode, otp) {
        var params = profileParams;
        if (lineIdToken) {
            params.id_token = lineIdToken;
        }
        if (refcode && otp) {
            params.refcode = refcode;
            params.otp = otp;
        }
        const url = ConfigManager.getApiUrl() + "/line/register";
        return BzbsApi.connectBzbsPost(url, null, params, null, null).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * Change Contact number
     * @param {string} token
     * @param {string} contact_number New contact number
     * @param {string} refcode
     * @param {string} otp
     */
    changeContactNumber: function(token, contact_number, refcode, otp) {
        var params = {
            contact_number: contact_number,
            refcode: refcode,
            otp: otp
        };
        const url = ConfigManager.getApiUrl() + "/profile/me/contact_number";
        return BzbsApi.connectBzbsPost(url, token, params, null, null).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * Get QR
     * @param {object} token
     */
    apiGetQRCode: function(params, ewallet_token) {
        // ewallet_token ='.FdGgM4ypNqjKFDwDci1aaNrpDni9C-jxHhbYxQ7pNNH0-5WxNKyAiB90MRxLkUts-WeORHxkIvuGYQn_oV8UJU4-DNMMLMaWEbb0f-YzZjVLO4MfqI93j-w6cVrnVZAFbtHZxSKuPDG0Syg87OZ2UAEVNr7UzYjeWfc3qYiGOuiNtW-g6e_jWSaY0jDQ7lp8'
        const url = ConfigManager.getApiUrlwallet() + "/earn/code";
        return BzbsApi.connectBzbsGet(url, ewallet_token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    }
};
